import { Box } from '@mui/material';
import React from 'react';
import { Button } from '../../../blocks/Button';
import styles from './LoadMore.module.scss';

export type LoadMoreProps = {
	loading?: boolean;
	loadMore: () => unknown | Promise<unknown>;
	hasMore: boolean;
};

export const LoadMore: React.FC<LoadMoreProps> = ( {
	loading,
	loadMore,
	hasMore,
} ) =>
	hasMore ? (
		<Box className={ styles.container }>
			<Button
				className={ styles.button }
				variant='text'
				onClick={ ( event ) => {
					event.stopPropagation();
					void loadMore();
				} }
				loading={ loading }
			>
				Load more
			</Button>
		</Box>
	) : null;
